export default __webpack_public_path__ + "static/media/avatar_167.a1ecb670.png";